import { useState, useEffect } from "react";
import "./App.css";
import WidgetWrapper from "./WidgetWrapper";
import { getBusinessById } from "./services/token-fetcher";
import Spinner from './components/spinner/Spinner';


function App() {
  const [token, setToken] = useState<string>();
  const [error, setError] = useState(null);
  const query = new URLSearchParams(window.location.search)
  const businessId = query.get("business_id") || ""
  const partnerId = query.get("partner_id") || ""

  useEffect(() => {
    const getBusiness = async () => {
      try {
        const business = await getBusinessById(businessId, partnerId);
        setToken(business);
        if(businessId) {
          window.parent.postMessage({ type: 'IFRAME_LOADED' }, '*');
        }

      } catch (err: any) {
        setError(err.message || 'An error occurred while obtaining business data.');
      }
    };

    if (!businessId) return;

    getBusiness()
  }, []);

  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
        <p>Please try again.</p>
      </div>
    );
  }

  if (!token) {
    return (
      <div>
        <Spinner/>
      </div>
    );
  }

  return (
    <div className="App">
      <WidgetWrapper
        token={token}
        environment="production"
        onExit={(metadata: any) => console.log(metadata)}
        onExitV2={(metadata: any) => console.log(metadata)}
        style={{}}
        product="flex_loan"
      ></WidgetWrapper>
    </div>
  );
}

export default App;
